module.exports = __webpack_public_path__ + "562edca5bb39d66f4c9238a36295187b.svg";